import React, { useEffect,useState } from 'react';
import { Error403 } from "./ErrorPage/ErrorPage";
import { sbaAxios } from '../utils/sbaAxios';
import {getallowedmenus} from'../../config/apiConfig';


export const ProtectedRoute = ({ name,children}) => {
    const [menus,setMenus]=useState([]);
    const [render,setRender]=useState(false);
    useEffect(() => {
        const aFunc = () => {  
            sbaAxios({
              url: `${getallowedmenus}`,
              method: 'get',
            })
              .then(response => {
               setMenus(response.map((item, index) => {
                   return {  MenuName:item.MenuName }
               }));
                setRender(true);
              });
        }
        aFunc();
      }, [])
      if(render===true)
      {
    const dataNotExistsInMenus = menus.every((item) => item.MenuName !== name);
    console.log(dataNotExistsInMenus,"menu")
    if (dataNotExistsInMenus) {
      return (
      <div className='container403'> 
 <Error403></Error403> 
</div>
      )
    }
  }
    return children;
    
  };